<template>
  <header class="sticky top-0 z-50">
    <Disclosure as="nav" v-slot="{ open }">
      <div class="w-screen bg-gray-50 bg-opacity-95 dark:bg-black dark:bg-opacity-90">
        <div class="px-4 mx-auto max-w-7xl sm:px-8 lg:px-12">
          <div class="flex justify-between h-16">
            <div class="flex">
              <div class="flex items-center mr-2 -ml-2 md:hidden">
                <!-- Mobile menu button -->
                <DisclosureButton
                  class="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-slate-500"
                >
                  <span class="sr-only">Open main menu</span>
                  <MenuIcon v-if="!open" class="block w-6 h-6" aria-hidden="true" />
                  <XIcon v-else class="block w-6 h-6" aria-hidden="true" />
                </DisclosureButton>
              </div>
              <div class="flex items-center flex-shrink-0">
                <logo-svg @click="navSelected = 'hero'" class="w-auto h-8 cursor-pointer" />
              </div>
              <div class="hidden md:ml-6 md:flex md:space-x-4">
                <template v-for="element in nav.elements" :key="element">
                  <a
                    :href="element.href"
                    class="inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2"
                    @click="navSelected = element.name"
                    :class="[
                      navSelected == element.name
                        ? 'border-slate-500 text-gray-900 dark:border-pink-500 dark:text-white'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-200 dark:hover:border-gray-700 dark:hover:text-gray-200',
                      element.name === 'Sign Up' ? 'sm:pl-6 md:pl-12 lg:pl-20' : '',
                    ]"
                  >
                    {{ element.name }}
                  </a>
                </template>
              </div>
            </div>
            <div class="flex items-center space-x-5">
              <div class="flex-shrink-0 hidden sm:block">
                <!-- <a
                  @click="logClickEvent('extension_install_button__top')"
                  :href="chromeExtension.url"
                  class="relative inline-flex items-center hidden px-4 py-2 text-sm font-medium text-black text-gray-800 rounded-md shadow-sm bg-slate-100 hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 sm:flex"
                >
                  <img src="../assets/chrome-icon.svg" class="w-5 h-5 mr-2" />

                  <span>Add to Chrome</span>
                </a> -->
                <router-link
                  :to="pathToAuth"
                  class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-800 capitalize rounded-md shadow-sm bg-slate-100 hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 sm:flex"
                >
                  Try for free
                </router-link>
              </div>
              <div class="flex-shrink-0">
                <router-link
                  :to="`${pathToAuth}&login=true`"
                  class="text-gray-400 border-transparent hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-gray-700 dark:hover:text-gray-200"
                >
                  Login
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DisclosurePanel class="md:hidden">
        <div class="pt-2 pb-3 space-y-1 bg-white/95 dark:bg-black/95">
          <template v-for="element in nav.elements" :key="element">
            <DisclosureButton
              as="a"
              :href="element.href"
              class="block py-2 pl-3 pr-4 text-base font-medium border-l-4 sm:pl-5 sm:pr-6"
              @click="navSelected = element.name"
              :class="[
                navSelected == element.name
                  ? 'border-slate-500 bg-slate-50 text-slate-700 dark:border-pink-500 dark:bg-slate-900 dark:text-pink-700'
                  : 'dark:hover-gray-700 border-transparent text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700 dark:text-gray-200 dark:hover:bg-gray-800 dark:hover:text-gray-200',
              ]"
            >
              {{ element.name }}
            </DisclosureButton>
          </template>
        </div>
      </DisclosurePanel>
    </Disclosure>
  </header>

  <!-- <img src="../assets/bg-hero.svg" alt="background-gradient" class="absolute inset-0 block dark:hidden" />
  <img src="../assets/bg-hero-dark.svg" alt="background-gradient-dark" class="absolute inset-0 hidden dark:block" /> -->

  <main class="scroll-smooth bg-gradient-to-r from-indigo-50/60 via-purple-50/50 to-pink-50/60 dark:from-slate-900/90 dark:via-gray-900/90 dark:to-slate-900/90">
    <div class="px-4 mx-auto -mt-16 max-w-7xl sm:px-8 lg:px-12">
      <!-- Hero Section -->
      <main id="hero" class="relative flex items-center justify-center h-screen my-auto">
        <div class="text-center">
          <!-- <h1 class="max-w-5xl px-4 text-4xl font-bold tracking-normal text-transparent break-words sm:text-5xl md:text-5xl lg:text-7xl">
            <span class="animate-move-bg bg-gradient-to-r from-pink-600 via-purple-400 to-purple-600 bg-[length:400%] bg-clip-text">Remember</span>
            <span class="ml-2 text-gray-900 dark:text-white">anything you read, watch or listen to.</span>
          </h1> -->
          <h1 class="mx-4 mb-10 text-5xl font-bold tracking-tight text-transparent break-words sm:text-6xl md:text-7xl">
            <span class="mr-2 text-gray-900 dark:text-white">Become the</span>
            <span class="animate-move-bg bg-gradient-to-r from-pink-600 via-purple-400 to-purple-600 bg-[length:400%] bg-clip-text">smartest you</span>
            <span class="ml-2 text-gray-900 dark:text-white">can be.</span>
          </h1>
          <h3 class="px-4 mx-auto text-lg text-black dark:text-gray-300 md:max-w-4xl md:text-xl">
            Compound your knowledge and learn from your favourite news articles, blog posts, podcasts, YouTube videos,...
          </h3>
          <div class="w-screen px-4 mx-auto mt-5 overflow-x-auto hide-scrollbar sm:mx-auto sm:max-w-3xl md:mt-10" ref="channelCloud">
            <div class="flex py-5 space-x-5 item-center">
              <template v-for="icon in channelIconList" :key="icon">
                <div class="flex items-center p-3 bg-white rounded-full shadow-lg dark:bg-black">
                  <v-icon :name="icon" class="w-8 h-8 m-auto text-gray-800 dark:text-gray-300 sm:h-10 sm:w-10" />
                </div>
              </template>
            </div>
          </div>
          <!-- <p class="px-4 mx-auto mt-10 text-base text-gray-500 dark:text-gray-300 sm:text-lg md:max-w-4xl md:mt-16 md:text-xl">
            90% of the information that we consume online is forgotten within 7 days. Wisery enables you to remember, retain & recollect information to build lasting knowledge.
          </p> -->

          <div class="block max-w-md mx-auto mt-14 md:mt-16">
            <!-- <router-link
              :to="pathToAuth"
              class="justify-center px-4 py-3 text-xl font-medium text-white capitalize border-none rounded-md shadow-lg bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-400 hover:to-purple-400 dark:from-pink-600 dark:to-purple-600 sm:text-3xl md:px-6 md:py-4"
            >
              Try for free
            </router-link> -->
            <router-link
              :to="pathToAuth"
              class="justify-center px-4 py-3 text-xl font-medium text-white capitalize bg-black rounded-md shadow-lg hover:bg-gray-800 dark:bg-gray-200 dark:text-black dark:hover:bg-gray-300 sm:text-3xl md:px-6 md:py-4"
            >
              Try for free
            </router-link>
          </div>
        </div>
      </main>

      <!-- Forgetting Curve -->
      <div id="forgetting-curve" class="scroll-mt-20 sm:mt-0 sm:flex sm:items-center sm:space-x-12 sm:space-y-0 sm:pb-20 sm:pt-0">
        <!-- Left side CTA -->
        <div class="sm:w-2/5">
          <div class="lg:self-center">
            <h2 class="text-3xl font-extrabold text-gray-900 dark:text-white sm:text-5xl lg:text-4xl">We forget, a lot</h2>
            <p class="mt-4 text-lg leading-6 text-gray-600 dark:text-gray-300 lg:text-xl">
              Hermann Ebbinghaus' Forgetting Curve is a graph that shows how much and how fast we forget information over time.
            </p>
            <p class="mt-4 text-lg leading-6 text-gray-600 dark:text-gray-300 lg:text-xl">How much detail do you remember from something you read a week ago?</p>
          </div>
        </div>
        <!-- Forgetting Curve -->
        <div class="my-5 sm:my-0 sm:w-3/5">
          <div class="p-4 rounded-md shadow-lg dark:shadow-gray-900 md:p-6">
            <!-- <p class="text-2xl font-bold text-gray-900">Combat the forgetting curve</p> -->
            <img class="object-cover w-full h-full dark:hidden" src="../assets/forgetting-curve.svg" />
            <img class="hidden object-cover w-full h-full dark:block" src="../assets/forgetting-curve-dark.svg" />
          </div>
          <div class="mt-5 text-gray-900 dark:text-white sm:text-lg">
            <p class="p-3 text-blue-600 bg-blue-100 border-l-4 border-r-4 border-blue-700 rounded-md">
              If you read something interesting today, 7 days later only 5-10% of key information will remain in your memory. After 30 days, 1-2%.
            </p>
          </div>
        </div>
      </div>

      <!-- How Wisery works -->
      <div id="how-wisery-works" class="mt-20 scroll-mt-20">
        <h2 class="text-3xl font-extrabold text-gray-900 dark:text-white sm:text-5xl lg:text-4xl">How Wisery works</h2>
        <div class="w-full mt-20 space-y-20 sm:flex sm:space-x-5 sm:space-y-0">
          <div class="relative flex-col w-full p-4 rounded-lg shadow-lg bg-white/50 dark:bg-gray-900/50 dark:shadow-gray-700 sm:w-1/3">
            <div class="absolute inset-x-0 flex justify-center w-full text-center -top-7">
              <div class="relative flex items-center justify-center p-2 text-xl text-center text-white rounded-full h-14 w-14 bg-slate-400 dark:bg-slate-700">1</div>
            </div>
            <div class="mt-10">
              <div class="pb-6">
                <div class="text-2xl font-bold leading-6 text-gray-900 dark:text-white">Save Interesting Content</div>
                <div class="mt-2 text-gray-600 text-md dark:text-gray-300">Many options to conveniently save a blog, YouTube Video, PDF, Text,...</div>
              </div>
              <div class="space-y-3">
                <div class="flex items-center p-2 my-5 space-x-2 border border-gray-200 rounded-md dark:border-gray-500">
                  <DeviceMobileIcon class="w-6 h-6 text-black dark:text-gray-400 sm:h-10 sm:w-10" />
                  <div class="text-gray-900 dark:text-white">Save links via WhatsApp or SMS</div>
                </div>
                <div class="flex items-center p-2 my-5 space-x-2 border border-gray-200 rounded-md dark:border-gray-500">
                  <DesktopComputerIcon class="w-6 h-6 text-black dark:text-gray-400 sm:h-10 sm:w-10" />
                  <div class="text-gray-900 dark:text-white">Use the Chrome extension</div>
                </div>
                <div class="flex items-center p-2 my-5 space-x-2 border border-gray-200 rounded-md dark:border-gray-500">
                  <FolderIcon class="w-6 h-6 text-black dark:text-gray-400 sm:h-10 sm:w-10" />
                  <div class="text-gray-900 dark:text-white">Upload any text document</div>
                </div>

                <div class="flex items-center p-2 my-5 space-x-2 border border-gray-200 rounded-md dark:border-gray-500">
                  <DocumentTextIcon class="w-6 h-6 text-black dark:text-gray-400 sm:h-10 sm:w-10" />
                  <div class="text-gray-900 dark:text-white">Enter & save text</div>
                </div>
              </div>
            </div>
          </div>
          <div class="relative flex-col w-full p-4 rounded-lg shadow-lg bg-white/50 dark:bg-gray-900/50 dark:shadow-gray-700 sm:w-1/3">
            <div class="absolute inset-x-0 flex justify-center w-full text-center -top-7">
              <div class="relative flex items-center justify-center p-2 text-xl text-center text-white rounded-full h-14 w-14 bg-slate-400 dark:bg-slate-700">2</div>
            </div>
            <div class="mt-10">
              <div class="pb-6">
                <div class="text-2xl font-bold leading-6 text-gray-900 dark:text-white">Content Summaries+</div>
                <div class="mt-2 text-gray-600 text-md dark:text-gray-300">Wisery extracts key information and creates summaries and engaging micro-learning units such as quiz questions.</div>
              </div>

              <div class="flex flex-col items-center mt-5">
                <!-- <img src="../assets/open-ai-logo.svg" alt="How to generate a summary with Wisery" class="w-2/5 mt-3" /> -->
                <open-ai-logo class="w-1/2 mt-3 fill:black dark:fill-white" />

                <PlusSmIcon class="w-8 h-8 my-4 dark:text-white" />

                <div class="flex p-3 -space-x-2 overflow-hidden">
                  <img
                    class="inline-block w-12 h-12 rounded-full ring-2 ring-white dark:ring-slate-600"
                    src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80"
                    alt="person-avatar-1"
                  />
                  <img
                    class="inline-block w-12 h-12 rounded-full ring-2 ring-white dark:ring-slate-600"
                    src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt="person-avatar-2"
                  />
                  <img
                    class="inline-block w-12 h-12 rounded-full ring-2 ring-white dark:ring-slate-600"
                    src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80"
                    alt="person-avatar-3"
                  />
                  <img
                    class="inline-block object-cover w-12 h-12 rounded-full ring-2 ring-white dark:ring-slate-400"
                    src="https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1467&q=80"
                    alt="person-avatar-4"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="relative flex-col w-full p-4 rounded-lg shadow-lg bg-white/50 dark:bg-gray-900/50 dark:shadow-gray-700 sm:w-1/3">
            <div class="absolute inset-x-0 flex justify-center w-full text-center -top-7">
              <div class="relative flex items-center justify-center p-2 text-xl text-center text-white rounded-full h-14 w-14 bg-slate-400 dark:bg-slate-700">3</div>
            </div>
            <div class="mt-10">
              <div class="pb-6">
                <div class="text-2xl font-bold leading-6 text-gray-900 dark:text-white">Short Reviews</div>
                <div class="mt-2 text-gray-600 text-md dark:text-gray-300">Review only what you need and when you need.</div>
              </div>

              <div class="flex flex-col mt-5">
                <div class="space-y-8">
                  <template v-for="feature in dailyReviewFeatures" :key="feature">
                    <div class="flex items-start">
                      <component :is="feature.icon" class="flex-shrink-0 w-8 h-8 text-green-500" />
                      <div class="block ml-4">
                        <div class="text-lg dark:text-white">{{ feature.title }}</div>
                        <div class="text-gray-600 dark:text-gray-300">{{ feature.description }}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="relative px-4 mx-auto mt-32 space-y-32 max-w-7xl sm:px-8 lg:px-12">
      <img src="../assets/bg-hero.svg" alt="background-gradient" class="absolute inset-0 justify-center block w-screen dark:hidden" />
      <img src="../assets/bg-blur-1-dark.svg" alt="background-gradient-dark" class="absolute inset-0 justify-center hidden w-screen dark:block" />

      <!-- Daily reviews -->
      <div id="daily-reviews" class="scroll-mt-20">
        <h2 class="text-3xl font-extrabold text-gray-900 dark:text-white sm:text-5xl lg:text-4xl">Short content reviews</h2>
        <p class="mt-2 text-xl text-gray-600">How and why they work</p>
        <div class="w-full mt-10 sm:space-y-5">
          <div class="relative max-w-5xl mx-auto space-y-16 sm:space-y-32 sm:px-10">
            <div class="sm:flex sm:items-center sm:space-x-32">
              <div class="block space-y-2 sm:w-1/2">
                <div class="text-xl font-semibold dark:text-white sm:text-3xl">Focusing on key information</div>
              </div>
              <div class="py-5 space-y-5 dark:text-gray-300 sm:w-1/2 sm:space-y-10">
                <div class="space-y-2">
                  <div class="flex space-x-2 flex-ro">
                    <div class="h-5 bg-gray-200 rounded-md basis-1/4 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/3 dark:bg-gray-600"></div>
                    <div class="h-5 rounded-md basis-1/5 bg-slate-700 dark:bg-red-800"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/6 dark:bg-gray-600"></div>
                  </div>
                  <div class="flex flex-row space-x-2">
                    <div class="h-5 bg-gray-200 rounded-md basis-1/6 dark:bg-gray-600"></div>
                    <div class="h-5 rounded-md basis-1/6 bg-slate-700 dark:bg-red-800"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-2/5 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-3/6 dark:bg-gray-600"></div>
                  </div>
                  <div class="flex flex-row space-x-2">
                    <div class="h-5 bg-gray-200 rounded-md basis-1/6 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/3 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-2/6 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/5 dark:bg-gray-600"></div>
                  </div>
                  <div class="flex flex-row space-x-2">
                    <div class="h-5 bg-gray-200 rounded-md basis-1/5 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/4 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/6 dark:bg-gray-600"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/3 dark:bg-gray-600"></div>
                    <div class="h-5 rounded-md basis-1/5 bg-slate-700 dark:bg-red-800"></div>
                    <div class="h-5 bg-gray-200 rounded-md basis-1/3 dark:bg-gray-600"></div>
                  </div>
                </div>
                <div class="text-base text-gray-600 dark:text-gray-300">
                  <div>Wisery extracts key information, facts and figures from your saved content. This raw information is then contextualized, summarized and converted to knowledge units.</div>
                </div>
              </div>
            </div>

            <div class="space-y-10 sm:flex sm:flex-row-reverse sm:items-center sm:space-y-0">
              <div class="space-y-2 sm:ml-32 sm:w-1/2">
                <div class="text-xl font-semibold dark:text-white sm:text-3xl">Feynman technique (active recall)</div>
              </div>
              <div class="space-y-5 sm:w-1/2 sm:space-y-10">
                <img src="../assets/feynman.svg" class="dark:hidden" />
                <img src="../assets/feynman-dark.svg" class="hidden dark:block" />
                <div class="text-gray-600 dark:text-gray-300">
                  <div>Wisery incorporates active recall tasks based on the famous Feynman method - teach what you know to a 12-year old.</div>
                </div>
              </div>
            </div>

            <div class="space-y-5 sm:flex sm:items-center sm:space-x-32 sm:space-y-0">
              <div class="block space-y-2 sm:w-1/2">
                <div class="text-xl font-semibold dark:text-white sm:text-3xl">Spaced repetition</div>
              </div>
              <div class="space-y-10 sm:w-1/2">
                <img src="../assets/spaced-repetition.svg" class="object-cover h-52" />
                <div class="text-gray-600 dark:text-gray-300">
                  <div>
                    All your content reviews are paced to your individual progress and usually only take 3-5 minutes to complete (once a day). It'll be your most impactful new habit. Many users report
                    noticeable knowledge progress after only 2 weeks.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pricing -->
      <div id="pricing" class="scroll-mt-20">
        <div class="sm:rounded-lg sm:bg-white/50 sm:p-12 sm:dark:bg-gray-900/50">
          <div class="mx-auto max-w-7xl">
            <div class="pb-5 sm:pb- xl:flex xl:items-center xl:justify-between">
              <div>
                <h1 class="text-4xl font-extrabold sm:text-5xl sm:tracking-tight">
                  <span class="text-gray-900 dark:text-white">Unlimited knowledge</span>
                  <span v-if="prices.length" class="ml-2 animate-move-bg bg-gradient-to-r from-pink-600 to-purple-600 bg-[length:400%] bg-clip-text tracking-normal text-transparent"
                    >for ${{ prices[0].unit_amount / 100 }}/{{ prices[0].interval }}.</span
                  >
                  <span v-else class="ml-2 animate-move-bg bg-gradient-to-r from-pink-600 to-purple-600 bg-[length:400%] bg-clip-text tracking-normal text-transparent">for $5.99/month.</span>
                </h1>
                <p class="mt-5 text-xl text-gray-500 dark:text-gray-300">Includes every feature, unlimited usage and 24/7 support. First 30 days completely free.</p>
              </div>
              <div class="flex justify-start w-auto text-center">
                <div class="block">
                  <router-link
                    :to="pathToAuth"
                    class="flex items-center justify-center px-3 py-2 mt-8 text-lg font-medium text-white capitalize bg-black rounded-md shadow-lg hover:bg-gray-800 dark:bg-gray-200 dark:text-black dark:hover:bg-gray-300 sm:text-xl md:px-6 md:py-4"
                  >
                    Try for free
                  </router-link>
                  <div class="mt-1 text-sm text-gray-500 dark:text-gray-300">No CC required.</div>
                </div>
              </div>
            </div>
            <div class="pt-5 border-t border-gray-200 sm:pt-10 xl:grid xl:grid-cols-3 xl:gap-x-8">
              <div>
                <h2 class="animate-move-bg bg-gradient-to-r from-pink-600 to-purple-600 bg-[length:50%] bg-clip-text text-base font-semibold uppercase tracking-wide text-transparent">
                  Everything you need
                </h2>
                <p class="mt-2 text-3xl font-extrabold text-gray-900 dark:text-white">Grow your knowledge seamlessly</p>
              </div>
              <div class="mt-4 sm:mt-8 md:mt-10 md:grid md:grid-cols-2 md:gap-x-8 xl:col-span-2 xl:mt-0">
                <ul role="list" class="divide-y divide-gray-200">
                  <template v-for="(feature, featureIdx) in features.slice(0, 4)" :key="feature">
                    <li v-if="featureIdx === 0" class="flex py-4 md:py-0 md:pb-4">
                      <CheckIcon class="flex-shrink-0 w-6 h-6 text-green-500" aria-hidden="true" />
                      <span class="ml-3 text-base text-gray-500 dark:text-gray-300">{{ feature }}</span>
                    </li>
                    <li v-else class="flex py-4">
                      <CheckIcon class="flex-shrink-0 w-6 h-6 text-green-500" aria-hidden="true" />
                      <span class="ml-3 text-base text-gray-500 dark:text-gray-300">{{ feature }}</span>
                    </li>
                  </template>
                </ul>
                <ul role="list" class="border-t border-gray-200 divide-y divide-gray-200 md:border-t-0">
                  <template v-for="(feature, featureIdx) in features.slice(4)" :key="feature">
                    <li v-if="featureIdx === 0" class="flex py-4 md:border-t-0 md:py-0 md:pb-4">
                      <CheckIcon class="flex-shrink-0 w-6 h-6 text-green-500" aria-hidden="true" />
                      <span class="ml-3 text-base text-gray-500 dark:text-gray-300">{{ feature }}</span>
                    </li>
                    <li v-else class="flex py-4">
                      <CheckIcon class="flex-shrink-0 w-6 h-6 text-green-500" aria-hidden="true" />
                      <span class="ml-3 text-base text-gray-500 dark:text-gray-300">{{ feature }}</span>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="relative px-4 pb-16 mx-auto mt-20 space-y-32 max-w-7xl sm:px-8 lg:px-12">
      <div class="absolute inset-0 -z-10">
        <img src="../assets/bg-hero.svg" class="block w-screen h-full dark:hidden" />
        <img src="../assets/bg-blur-1-dark.svg" class="hidden w-screen h-full dark:block" />
      </div>

      <!-- FAQs -->
      <div id="faqs" class="scroll-mt-20" v-if="faqs">
        <div class="max-w-4xl px-4 py-5 mx-auto rounded-lg bg-white/50 dark:bg-gray-900/50 sm:px-6 sm:py-12 lg:max-w-7xl lg:px-8">
          <div class="mx-auto divide-y-2 divide-gray-200 dark:divide-gray-600">
            <h2 class="text-3xl font-extrabold text-gray-900 dark:text-white sm:text-4xl">Frequently asked questions</h2>
            <dl class="mt-6 space-y-6 divide-y divide-gray-200 dark:divide-gray-600">
              <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
                <dt class="text-lg">
                  <DisclosureButton class="flex items-start justify-between w-full text-left text-gray-400">
                    <span class="font-medium text-gray-900 dark:text-white">
                      {{ faq.question }}
                    </span>
                    <span class="flex items-center ml-6 h-7">
                      <ChevronDownIcon :class="[open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform']" aria-hidden="true" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" class="pr-12 mt-2">
                  <div class="text-base text-gray-500 dark:text-gray-300">
                    <div v-html="faq.answer"></div>
                  </div>
                </DisclosurePanel>
              </Disclosure>
            </dl>
          </div>
        </div>
      </div>

      <!-- Questions? -->
      <div id="questions" class="scroll-mt-20">
        <div class="max-w-4xl px-4 py-16 mx-auto rounded-lg bg-white/50 dark:bg-gray-900/50 sm:px-6 sm:py-12 lg:flex lg:max-w-7xl lg:items-center lg:justify-between lg:px-8">
          <h2 class="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            <span cl>Got questions?</span>
            <span class="ml-2 animate-move-bg bg-gradient-to-r from-pink-600 to-purple-600 bg-[length:400%] bg-clip-text font-bold tracking-normal text-transparent">Get in touch.</span>
          </h2>
          <div class="mt-6 space-y-4 sm:flex sm:space-y-0 sm:space-x-5">
            <a
              href="mailto:hello@wisery.io"
              class="flex items-center justify-center rounded-md border px-3.5 py-2.5 text-lg font-medium text-gray-800 shadow-sm hover:bg-gray-50 dark:text-white dark:hover:bg-gray-800"
            >
              <MailIcon class="w-8 h-8 pr-2" />
              Email
            </a>

            <a
              href="https://calendly.com/wisery/30min"
              class="relative inline-flex w-full justify-center rounded-md border bg-origin-border px-3.5 py-2.5 text-lg font-medium capitalize text-gray-900 shadow-sm hover:bg-gray-50 dark:text-white dark:hover:bg-gray-800"
            >
              <VideoCameraIcon class="w-8 h-8 pr-2" />
              Schedule VC Call
            </a>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div class="text-center">
        <h2 class="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
          <span class="block">Ready to get started?</span>
        </h2>
        <div class="flex justify-center mt-4">
          <!-- <a
            @click="logClickEvent('extension_install_button_bottom')"
            :href="chromeExtension.url"
            class="inline-flex items-center px-5 py-3 mt-8 text-base text-xl font-medium text-gray-800 border border-transparent rounded-md shadow bg-slate-100 hover:bg-slate-200"
          >
            <img src="../assets/chrome-icon.svg" class="mr-2 h-7 w-7" />
            Add to Chrome, it's free</a
          > -->
          <router-link
            :to="pathToAuth"
            class="flex items-center justify-center px-3 py-2 mt-8 text-lg font-medium text-white capitalize bg-black rounded-md shadow-lg hover:bg-gray-800 dark:bg-gray-200 dark:text-black dark:hover:bg-gray-300 sm:text-xl md:px-6 md:py-4"
          >
            Try for free
          </router-link>
        </div>
      </div>
    </div>
  </main>
  <page-footer />
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/outline";

import {
  MenuIcon,
  XIcon,
  MailIcon,
  DocumentTextIcon,
  FolderIcon,
  VideoCameraIcon,
  AcademicCapIcon,
  DeviceMobileIcon,
  DesktopComputerIcon,
  FingerPrintIcon,
  EmojiHappyIcon,
  TrendingUpIcon,
} from "@heroicons/vue/outline";
import { CheckIcon, PlusSmIcon } from "@heroicons/vue/solid";
import LogoSvg from "../components/logos/LogoSvg.vue";
import { ref, watchEffect, onMounted, computed } from "vue";
import OpenAiLogo from "../components/logos/OpenAiLogo.vue";
import PageFooter from "../components/PageFooter.vue";
import chromeExtension from "../composables/chromeExtension";
import googleAnalytics from "../composables/googleAnalytics";
import { useRoute } from "vue-router";
import utilFunctions from "../composables/util";
export default {
  components: {
    PlusSmIcon,
    LogoSvg,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    MenuIcon,
    XIcon,
    MailIcon,
    VideoCameraIcon,
    CheckIcon,
    DeviceMobileIcon,
    DesktopComputerIcon,
    OpenAiLogo,
    PageFooter,
    DocumentTextIcon,
    FolderIcon,
    ChevronDownIcon,
  },
  setup() {
    const { logClickEvent } = googleAnalytics();
    const { stripePrices } = utilFunctions();
    const channelCloud = ref(null);

    const dailyReviewFeatures = [
      { title: "Effective", description: ">50% knowledge retention", icon: AcademicCapIcon },
      { title: "Lightweight", description: "3-5min per day", icon: EmojiHappyIcon },
      {
        title: "Personalized",
        description: "Based on your content and progress",
        icon: FingerPrintIcon,
      },
      {
        title: "Progress",
        description: "Closely track your knowledge progression",
        icon: TrendingUpIcon,
      },
    ];
    const nav = {
      elements: [
        {
          name: "Forgetting Curve",
          href: "#forgetting-curve",
        },
        {
          name: "How it works",
          href: "#how-wisery-works",
        },
        {
          name: "Daily Reviews",
          href: "#daily-reviews",
        },
        {
          name: "Pricing",
          href: "#pricing",
        },
        {
          name: "FAQs",
          href: "#faqs",
        },
        // {
        //   name: "Sign Up",
        //   href: "/auth",
        // },
        // {
        //   name: "Login",
        //   href: "/auth?login=true",
        // },
      ],
    };
    const navSelected = ref();
    const prices = ref([]);

    const channelIconList = [
      "bi-youtube",
      "bi-newspaper",
      "co-apple-podcasts",
      "bi-file-earmark-pdf",
      "co-google-podcasts",
      "si-substack",
      "bi-file-earmark-word",
      "co-wikipedia",
      "bi-medium",
      "md-chromereadermode-outlined",
      "md-morehoriz-sharp",
    ];
    const pathToAuth = ref("/auth");

    watchEffect(() => {
      if (navSelected.value == "hero") {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    });

    const features = [
      "Save content from anywhere",
      "All major content formats supported",
      "Personalised learning paths",
      "Powerful & proven knowledge growth tactics",
      "Simple and short reviews",
      "Detailed knowledge progress tracking",
      "Engaged community around your favorite topics.",
      "All your valuable content in one place",
    ];

    const currentRouteQuery = computed(() => {
      return useRoute().query;
    });

    const isMac = ref(true);
    const faqs = ref([
      {
        question: "Is Wisery for me?",
        answer:
          "Wisery is for you if you consume informational and/or educational content. Common examples are interesting podcasts or YouTube videos, Wikipedia articles, blog posts, news or newsletters. Wisery is especially powerful if you consume this content frequently. <p class='mt-5'>To get the most out of Wisery you should also have an active interest in growing your knowledge, either for your personal or professional life, or both.</p>",
      },
      {
        question: "How does Wisery work?",
        answer:
          "It's quite simple. <ol class='mt-1 list-decimal list-inside'><li>Save interesting content</li><li>Wisery summarizes it, creates micro-learnings and constructs a personalised reviews for you</li><li>You'll review content usually once a day for 2-4 minutes</li><li>Track your progress, earn rewards and compound your knowledge</li></ol>",
      },
      {
        question: "How do I save content?",
        answer:
          "<p class='mt-2'><span class='font-semibold'>On mobile</span><br/>Send to save any link to Wisery's WhatsApp or SMS channel</p><p class='mt-2'><span class='font-semibold'>On desktop</span><br/>Use Wisery's browser extension to seamlessly save content as you browse or work.</p>",
      },
      {
        question: "How do daily reviews work?",
        answer:
          "Reviews are based on your progress and your content. You typically have 1 review per day which takes 2-4 minutes to complete. Each review is a combination of content summaries, micro-learnings such as quiz questions or active recall tasks. Reviews are powered by powerful and proven knowledge growth tactics such as: <ul class='mt-1 list-decimal list-inside'><li>Feynman technique</li><li>Spaced repetition (paced to your progress)</li><li>Active recall</li></ul>",
      },
    ]);

    onMounted(async () => {
      let urlReferrer;
      if (currentRouteQuery.value.ref) urlReferrer = currentRouteQuery.value.ref;
      if (document.referrer) urlReferrer = currentRouteQuery.value;
      if (!urlReferrer) urlReferrer = null;

      pathToAuth.value += `?ref=${urlReferrer}`;

      isMac.value = navigator.userAgentData.platform.toLowerCase().indexOf("mac") >= 0 ? true : false;

      prices.value = await stripePrices();

      faqs.value.push({
        question: "How much does it cost?",
        answer: `The first 30 days are completely free, no credit card required and access to all features. After that, $${prices.value[0].unit_amount / 100}/${prices.value[0].interval} or $${
          prices.value[1].unit_amount / 100
        }/${prices.value[1].interval}`,
      });

      function scrollDelay(ms) {
        return new Promise((res) => setTimeout(res, ms));
      }

      for (var x = 0; x <= channelCloud.value.offsetWidth; x += 1.5) {
        channelCloud.value.scrollTo({ left: x, behavior: "smooth" });
        await scrollDelay(100);
      }

      // await stripePrices().forEach((price) => {
      //   prices.value.push(price);
      // });
      // console.log("prices", prices.value);
    });

    return {
      nav,
      chromeExtension,
      navSelected,
      features,
      dailyReviewFeatures,
      isMac,
      logClickEvent,
      prices,
      channelIconList,
      channelCloud,
      pathToAuth,
      faqs,
    };
  },
};
</script>
